import { render, staticRenderFns } from "./dados-pessoa-deficiente-visual.vue?vue&type=template&id=60ac0c72&"
import script from "./dados-pessoa-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./dados-pessoa-deficiente-visual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ac0c72')) {
      api.createRecord('60ac0c72', component.options)
    } else {
      api.reload('60ac0c72', component.options)
    }
    module.hot.accept("./dados-pessoa-deficiente-visual.vue?vue&type=template&id=60ac0c72&", function () {
      api.rerender('60ac0c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/dados-pessoa-deficiente-visual.vue"
export default component.exports